export class FindRsyncResult {
    targetOperation = -1;
    syncId = -1;
    failureDate = "";
    identifyCode = "";
    userCd = -1;
    userName = "";
    buknCd = -1;
    buknName = "";
    roomNo = "";
    nyukyokeiyakuNo = -1;
    nyukyokeiyakuName = "";
}
